"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInfo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 963.2C262.4 963.2 60.8 761.6 60.8 512S262.4 60.8 512 60.8 963.2 262.4 963.2 512 761.6 963.2 512 963.2zM454.4 448h112v310.4h-112V448zm118.4-121.6c0 35.2-28.8 60.8-60.8 60.8-35.2 0-60.8-28.8-60.8-60.8 0-35.2 28.8-60.8 60.8-60.8 35.2 0 60.8 28.8 60.8 60.8z"
  }));
}

var ForwardRef = React.forwardRef(SvgInfo);
var _default = ForwardRef;
exports.default = _default;